import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';
import NotificationsButton from './NotificationsButton';
import useLeadsNotification from 'domain/sales/lead/shared/notification/useLeadsNotification';
import useEmployeeComplianceDocumentNotifications from 'domain/people/employee/compliance/shared/notifications/useEmployeeComplianceDocumentNotifications';
import useCommercialStateNotifications from 'domain/projects/newProject/shared/notifications/useCommercialStateNotifications';
import ProjectNotification from 'domain/projects/newProject/shared/notifications/ProjectNotification';
import { useBrowserWarningNotifications } from 'framework/ui/BrowserWarningNotification';
import { MIN_SUPPORTED_BROWSER_VERSIONS } from 'infrastructure/browserConfig';
import useInterruptionNotifications from 'domain/people/availability/interruprions/notifications/useInterruptionNotifications';
import { NotificationItemProps } from 'infrastructure/notification/types';

const NotificationsHeader = () => {
  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(async () => getUserAlias());

  const leadNotifications = useLeadsNotification();
  const employeeComplianceDocumentNotifications = useEmployeeComplianceDocumentNotifications();
  const commercialStateNotifications = useCommercialStateNotifications(data => (
    <ProjectNotification response={data?.items ?? []} />
  ));
  const browserWarningNotifications = useBrowserWarningNotifications(MIN_SUPPORTED_BROWSER_VERSIONS, currentUserAlias);
  const interruptionNotifications = useInterruptionNotifications();
  const notificationItems = [
    ...leadNotifications,
    ...interruptionNotifications,
    ...commercialStateNotifications,
    ...employeeComplianceDocumentNotifications,
    ...browserWarningNotifications,
  ].filter(Boolean) as NotificationItemProps[];

  return currentUserAlias ? <NotificationsButton items={notificationItems} /> : null;
};

export default NotificationsHeader;
